import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../component/Header";
import Footer from "../../component/Footer";
import ProductCardSkeleton from "../../component/ProductCardSkeleton";
import HeadingSkeleton from "../../component/HeadingSkeleton";
import $ from "jquery";
import { API_BASE_URL, IMAGE_URL } from "../../utils/app_url";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import { NotificationManager } from "react-notifications";

const playIcon = require("../../assets/img/play-icon.svg").default;

const FairTradeVideos = () => {
  const { user } = useAuth();
  const { selectedLanguage, langJson } = useLanguage();
  const { storeId } = useParams();
  const [openModal, setOpenModal] = useState();
  const [videoList, setVideoList] = useState()
  const [loading, setLoading] = useState(true);
  const [selectedVideoIndex, setSelectedVideoIndex] = useState(null);
  const [showVideoPermission, setShowVideoPermission] = useState(false);
  const [pendingVideoIndex, setPendingVideoIndex] = useState(null);



  const fetchVideo = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}frontend/videos`, {
        method: "POST",
        body: JSON.stringify({
          store_id: storeId,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.authorisation?.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        setVideoList(responseData.data.data);
      } else {
        NotificationManager.warning(responseData?.msg);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleAddStore = async () => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}frontend/liked-stores`, {
          method: "POST",
          body: JSON.stringify({
            store_id: storeId,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          // setResponseStatus(responseData?.msg);
          NotificationManager.success(responseData?.msg);
        } else {
          // setResponseStatus(responseData?.msg);
          NotificationManager.warning(responseData?.msg);
        }
      } catch (error) { }
    }
  };

  const handleRequestPrice = async () => {
    if (!user) {
      $(".loginLink").click(() => {
        $(".loginPopup").addClass("active");
      });
      setOpenModal(!openModal);
    } else {
      try {
        const response = await fetch(`${API_BASE_URL}frontend/request-price`, {
          method: "POST",
          body: JSON.stringify({
            store_id: storeId,
            lang: selectedLanguage,
          }),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          NotificationManager.success(responseData?.msg);
        } else {
          NotificationManager.warning(responseData?.msg);
        }
      } catch (error) { }
    }
  };

  useEffect(() => {
    fetchVideo();
  }, []);

  const handleVideoClick = (index) => {
    setPendingVideoIndex(index);
    setShowVideoPermission(true);
  };

  const handleConfirmVideo = () => {
    setShowVideoPermission(false);
    setSelectedVideoIndex(pendingVideoIndex);
    setPendingVideoIndex(null);
  };

  const selectedVideo = selectedVideoIndex !== null ? videoList?.[selectedVideoIndex] : null;

  const getYouTubeEmbedUrl = (videoId) => {
    if (!videoId) return '';
    if (videoId.includes('youtube.com') || videoId.includes('youtu.be')) {
      const match = videoId.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&\n?#]+)/);
      return `https://www.youtube.com/embed/${match?.[1] || videoId}`;
    }
    return `https://www.youtube.com/embed/${videoId}`;
  };

  return (
    <div className="categoryDiv productSliderMain topNew tradePrdts">
      <div className="fullContainer">
        <div className="featureDiv productListMain">
          {loading ? (
            <HeadingSkeleton width="200px" height="28px" />
          ) : (
            <h2 className="storeTabHdn">{langJson?.videos}</h2>
          )}
          <ul className="eventList videosList products products-5-col">
            {loading ? (
              Array.from({ length: 5 }).map((_, index) => (
                <ProductCardSkeleton key={index} />
              ))
            ) : videoList?.length > 0 ? (
              videoList?.map((item, index) => (
                <li key={index}>
                  <div
                    onClick={() => handleVideoClick(index)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="videoHldr">
                      {item?.image ? (
                        <img src={item?.image} alt={item?.title} />
                      ) : (
                        <div style={{
                          width: '100%',
                          height: '237px',
                          backgroundColor: '#f0f0f0',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '48px',
                          borderRadius: '5px'
                        }}>
                          📹
                        </div>
                      )}
                      <img src={playIcon} alt="" className="playBtn" />
                    </div>
                    <h3>{item?.title}</h3>
                  </div>
                </li>
              ))
            ) : (
              <span className="noOrderDiv">{langJson?.norecordsfound}</span>
            )
            }
          </ul>
        </div>
      </div>

      {showVideoPermission && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9998
        }}>
          <div style={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: "40px",
            textAlign: "center",
            maxWidth: "500px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
          }}>
            <h3 style={{ marginBottom: "16px", fontSize: "20px", fontWeight: "600" }}>
              {langJson?.videoPermission || "Video-Berechtigung erforderlich"}
            </h3>
            <p style={{ marginBottom: "24px", fontSize: "14px", color: "#666" }}>
              {langJson?.videoPermissionMessage || "Bitte bestätigen Sie, dass Sie dieses Video ansehen möchten. Dies ist eine Bestätigung des Kunden."}
            </p>
            <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
              <button
                onClick={() => {
                  setShowVideoPermission(false);
                  setPendingVideoIndex(null);
                }}
                style={{
                  padding: "12px 32px",
                  backgroundColor: "#e9ecef",
                  color: "#333",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                  fontWeight: "600"
                }}
              >
                {langJson?.cancel || "Abbrechen"}
              </button>
              <button
                onClick={handleConfirmVideo}
                onMouseEnter={(e) => e.target.style.backgroundColor = "#000"}
                onMouseLeave={(e) => e.target.style.backgroundColor = "#475168"}
                style={{
                  padding: "12px 32px",
                  backgroundColor: "#475168",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontSize: "16px",
                  fontWeight: "600",
                  transition: "background-color 0.3s ease"
                }}
              >
                {langJson?.confirm || "Bestätigen"}
              </button>
            </div>
          </div>
        </div>
      )}

      {selectedVideo && (
        <div className="modalOverlay" onClick={() => setSelectedVideoIndex(null)}>
          <div className="videoModal" onClick={(e) => e.stopPropagation()}>
            <button
              className="zoom-modal-close"
              onClick={() => setSelectedVideoIndex(null)}
            >
              ×
            </button>
            <h2>{selectedVideo?.title}</h2>
            <div className="videoPlayerContainer">
              {selectedVideo?.type === 'upload' ? (
                <video width="100%" controls style={{ borderRadius: '10px' }}>
                  <source src={selectedVideo?.url} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              ) : (
                <iframe
                  width="100%"
                  height="600"
                  src={getYouTubeEmbedUrl(selectedVideo?.video_id || selectedVideo?.url)}
                  frameBorder="0"
                  allowFullScreen
                  style={{ borderRadius: '10px' }}
                ></iframe>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FairTradeVideos;
